import { useMemo } from 'react';
import { translationService } from './translations';

export const useTranslations = () => useMemo(() => translationService.getTranslations(), []);
